(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ft-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ft-hero-slideshow')) {
  customElements.define('ft-hero-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (this.slides.length < 2 || this.events) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.current = 0;
      this.animations = [];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.focused = false;
      this.editorSelected = false;
      this.querySelector('.ft-slideshow-controls').hidden = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-next')) this.show(this.current + 1, 1);
        else if (button.hasAttribute('data-previous')) this.show(this.current - 1, -1);
        else if (button.hasAttribute('data-slide-to')) this.show(Number(button.dataset.slideTo));
      }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
      this.addEventListener('pointerdown', event => { this.touch = event.pointerType === 'touch' ? { x:event.clientX, y:event.clientY } : null; }, options);
      this.addEventListener('pointerup', event => {
        if (!this.touch) return;
        const x = event.clientX - this.touch.x, y = event.clientY - this.touch.y;
        if (Math.abs(x) > 50 && Math.abs(x) > Math.abs(y) * 1.5) this.show(this.current + (x < 0 ? 1 : -1), x < 0 ? 1 : -1);
        this.touch = null;
      }, options);
      this.addEventListener('pointercancel', () => { this.touch = null; }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', event => { this.paused = event.matches; this.schedule(); }, options);
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.indexOf(event.target.closest('[data-slide]'));
        if (index >= 0) { this.editorSelected = true; this.show(index); }
      }, options);
      this.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); }, options);
      this.schedule();
    }
    show(index, direction) {
      const next = (index + this.slides.length) % this.slides.length;
      if (next === this.current) { this.schedule(); return; }
      direction = direction || (next > this.current ? 1 : -1);
      this.animations.forEach(animation => animation.cancel());
      this.slides.forEach(slide => slide.classList.remove('is-leaving'));
      const old = this.slides[this.current], active = this.slides[next];
      old.classList.remove('is-active'); old.classList.add('is-leaving');
      old.setAttribute('aria-hidden', 'true'); old.inert = true;
      active.classList.add('is-active'); active.removeAttribute('aria-hidden'); active.inert = false;
      this.current = next;
      this.querySelectorAll('[data-slide-to]').forEach((button, i) => button.setAttribute('aria-current', String(i === next)));
      const duration = this.motion.matches ? 0 : 650;
      this.animations = [
        old.animate([{transform:'translateX(0)'},{transform:`translateX(${-direction * 100}%)`}],{duration,easing:'cubic-bezier(.25,.1,.25,1)'}),
        active.animate([{transform:`translateX(${direction * 100}%)`},{transform:'translateX(0)'}],{duration,easing:'cubic-bezier(.25,.1,.25,1)'})
      ];
      this.animations[0].onfinish = () => old.classList.remove('is-leaving');
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      const stopped = this.paused || this.focused || this.editorSelected || document.hidden;
      this.querySelector('.ft-hero-slides').setAttribute('aria-live', stopped ? 'polite' : 'off');
      if (!stopped) this.timer = setTimeout(() => this.show(this.current + 1, 1), Number(this.dataset.interval));
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.animations?.forEach(animation => animation.cancel());
      this.events?.abort();
      this.events = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
